import React, { useMemo } from 'react';
import {
    getRecommendations,
    resultRecommendationsSlice
} from '../../../../store/reducers/resultRecommendationsSlice';
import { RecommendationsWrap } from './styles';
import TestListItem from '../../../molecules/TestListItem/TestListItem';
import GenericLazyLoadComponent from '../../../organisms/GenericLazyLoadComponent/GenericLazyLoadComponent';
import Grid from '../../../molecules/Grid';
import { useTranslation } from 'react-i18next';
import { InnerContainer } from '../../../atoms/Containers';
import useRecommendationsTracker from '../../../../core/hooks/useRecommendationsTracker';
import {ResultH2} from '@/pages/result/styles';
import { useSelector } from 'react-redux';
import { selectTestId } from '@/store/selectors/testIdSelector';

interface ResultRecommendationsProps {}

const ResultRecommendations: React.FC<ResultRecommendationsProps> = ({}) => {
    const { t } = useTranslation();
    const text_article = t('recommendations.title' as any);
    const testId = useSelector(selectTestId);

    const { recommendationRef, setClickId } = useRecommendationsTracker(testId);

    const fetchAction = useMemo(() => {
        if (testId) {
            return getRecommendations(testId);
        }
        return null;
    }, [testId]);

    return (
        <RecommendationsWrap>
            <InnerContainer>
                <Grid col='1' gap='1' margin='4' centeredContent>
                    <ResultH2>{text_article}</ResultH2>
                    <div ref={recommendationRef}>
                        {testId && fetchAction && (<GenericLazyLoadComponent
                            slice={resultRecommendationsSlice}
                            fetchAction={fetchAction}
                            renderItem={(test, index) => (
                                <TestListItem
                                    key={index}
                                    url={test.url}
                                    name={test.name}
                                    preview_picture={test.preview_picture}
                                    id={test.id}
                                    className='js-recommend-item'
                                    onClick={() => setClickId(test.id)}
                                />
                            )}
                        />)}
                    </div>
                </Grid>
            </InnerContainer>
        </RecommendationsWrap>
    );
};

export default ResultRecommendations;
